export const SEND_SUBSCRIPTION_REQUEST = 'SEND_SUBSCRIPTION_REQUEST';
export const SEND_SUBSCRIPTION_RESPONSE = 'SEND_SUBSCRIPTION_RESPONSE';
export const SEND_SUBSCRIPTION_FAILURE = 'SEND_SUBSCRIPTION_FAILURE';
export const GET_SUBSCRIPTIONS_REQUEST = 'GET_SUBSCRIPTIONS_REQUEST';
export const GET_SUBSCRIPTIONS_RESPONSE = 'GET_SUBSCRIPTIONS_RESPONSE';
export const GET_SUBSCRIPTIONS_FAILURE = 'GET_SUBSCRIPTIONS_FAILURE';
